import React, { useEffect, useState } from 'react';
import { getForms } from '../../actions/formActions';
import { listStocks, emptyListStocks } from '../../actions/stocksActions';
import { useDispatch, useSelector } from 'react-redux';
import SearchBoxWithListing from '../Common/SearchBoxWithListing';

const ManageStocks = (props) => {
  const searchBoxKey = "stock_search_form";
  const listFormKey = "stock_list_form";
  const dispatch = useDispatch();
  const stockState = useSelector((state) => state.stocks);
  const formState = useSelector((state) => state.forms);
  const { formJson = {} } = formState;
  const searchBoxJson = formJson[searchBoxKey] || {};
  const { listing = {} } = stockState;

  useEffect(() => {
    dispatch(emptyListStocks());
  }, []);

  const listApi = (data) => {
    return dispatch(listStocks(data, listFormKey));
  }

  return (
    <div>
      <SearchBoxWithListing
        searchBoxKey={searchBoxKey}
        listFormKey={listFormKey}
        fetchForm={getForms}
        listApi={listApi}
        searchBoxJson={searchBoxJson}
        listingData={listing}
      />
    </div>

  )
}

export default ManageStocks;
